module.exports = __webpack_public_path__ + "a78b3e53415d7b3d0d520ef2ad9ba4d3.pdf";